<template>
    <div class="container elegant">
        <div class="row">
            <div id="content-faq" class="col-lg-offset-2
                        col-lg-8
                        col-md-offset-1
                        col-md-10">
                <h1 class="diet text-center">Koio deal FAQ</h1>

                <!-- 全部展开/收起按钮 -->
                <div v-if="faqList && faqList.length > 0 && !loading" class="text-center" style="margin-bottom: 30px;">
                    <button class="btn-toggle-all" @click="toggleAll">
                        <i class="fa" :class="allExpanded ? 'fa-compress' : 'fa-expand'"></i>
                        {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                    </button>
                </div>

                <!-- 加载状态 -->
                <div v-if="loading" class="text-center" style="padding: 60px 0;">
                    <i class="fa fa-spinner fa-spin" style="font-size: 48px; color: #999;"></i>
                    <p style="margin-top: 20px; color: #999;">Loading FAQ...</p>
                </div>

                <!-- FAQ 列表 -->
                <div v-else-if="faqList && faqList.length > 0">
                    <div v-for="faq in faqList" :key="faq.id" class="card faq-item">
                        <div class="faq-header" @click="toggleFaq(faq.id)">
                            <h3 class="faq-title">{{ faq.title }}</h3>
                            <i class="fa toggle-icon" :class="isExpanded(faq.id) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                        </div>
                        <transition name="slide-fade">
                            <div v-show="isExpanded(faq.id)" class="faq-body">
                                <div class="faq-content" v-html="faq.content"></div>
                                <div class="faq-meta">
                                    <span class="faq-type">{{ getFaqTypeLabel(faq.type) }}</span>
                                    <span class="faq-date">{{ formatDate(faq.createtime) }}</span>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <!-- 无数据状态 -->
                <div v-else class="card text-center" style="padding: 60px 20px;">
                    <i class="fa fa-question-circle" style="font-size: 48px; color: #ccc; margin-bottom: 20px;"></i>
                    <p style="color: #999; font-size: 16px;">No FAQ data available</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { commonApi } from '@/api'

export default {
    name: 'FAQ',
    data() {
        return {
            loading: false,
            faqList: [],
            userType: 1, // 1=买家, 2=卖家
            expandedFaqs: [] // 存储展开的FAQ ID
        }
    },
    async mounted() {
        await this.loadFAQ()
    },
    methods: {
        async loadFAQ() {
            try {
                this.loading = true
                // 根据当前页面类型获取对应的 FAQ
                // 如果是卖家 FAQ 页面，传 type=2，否则传 type=1
                const type = this.$route.path.includes('merchant') ? 2 : 1
                
                const response = await commonApi.getFaq(type)
                
                if (response.code === 1 && response.data) {
                    this.faqList = response.data
                    console.log('FAQ 数据加载成功:', this.faqList)
                } else {
                    console.error('FAQ 加载失败:', response.msg)
                }
            } catch (error) {
                console.error('Failed to load FAQ:', error)
            } finally {
                this.loading = false
            }
        },
        
        getFaqTypeLabel(type) {
            return type === '1' ? 'Buyer FAQ' : 'Seller FAQ'
        },
        
        formatDate(timestamp) {
            if (!timestamp) return ''
            const date = new Date(timestamp * 1000)
            return date.toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
            })
        },
        
        toggleFaq(faqId) {
            const index = this.expandedFaqs.indexOf(faqId)
            if (index > -1) {
                // 如果已展开，则收起
                this.expandedFaqs.splice(index, 1)
            } else {
                // 如果未展开，则展开
                this.expandedFaqs.push(faqId)
            }
        },
        
        isExpanded(faqId) {
            return this.expandedFaqs.includes(faqId)
        },
        
        toggleAll() {
            if (this.allExpanded) {
                // 全部收起
                this.expandedFaqs = []
            } else {
                // 全部展开
                this.expandedFaqs = this.faqList.map(faq => faq.id)
            }
        }
    },
    
    computed: {
        allExpanded() {
            return this.faqList.length > 0 && this.expandedFaqs.length === this.faqList.length
        }
    }
}
</script>

<style scoped>
.container.elegant {
    padding: 40px 15px;
    min-height: 100vh;
}

.diet {
    font-size: 42px;
    font-weight: 700;
    color: #000;
    margin-bottom: 20px;
}

.mar-20-bottom {
    margin-bottom: 20px;
}

.card {
    background: white;
    border-radius: 8px;
    padding: 30px;
    margin-bottom: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.faq-item {
    transition: transform 0.3s, box-shadow 0.3s;
    overflow: hidden;
}

.faq-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.faq-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.faq-header:hover .faq-title {
    color: #007bff;
}

.toggle-icon {
    font-size: 20px;
    color: #666;
    transition: transform 0.3s, color 0.3s;
    flex-shrink: 0;
    margin-left: 15px;
}

.faq-header:hover .toggle-icon {
    color: #007bff;
}

.faq-title {
    font-size: 24px;
    font-weight: 600;
    color: #000;
    margin: 0;
    padding: 0;
    border: none;
    transition: color 0.3s;
    flex: 1;
}

.faq-body {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 2px solid #f0f0f0;
}

.faq-content {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    margin-bottom: 20px;
}

.faq-content >>> h2,
.faq-content >>> h3 {
    margin-top: 25px;
    margin-bottom: 15px;
    font-weight: 600;
}

.faq-content >>> h2 {
    font-size: 22px;
    color: #000;
}

.faq-content >>> h3 {
    font-size: 18px;
    color: #333;
}

.faq-content >>> p {
    margin-bottom: 15px;
}

.faq-content >>> ul,
.faq-content >>> ol {
    margin-left: 20px;
    margin-bottom: 15px;
}

.faq-content >>> li {
    margin-bottom: 10px;
}

.faq-content >>> a {
    color: #007bff;
    text-decoration: none;
}

.faq-content >>> a:hover {
    text-decoration: underline;
}

.faq-content >>> b,
.faq-content >>> strong {
    font-weight: 600;
}

.faq-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    border-top: 1px solid #f0f0f0;
    font-size: 14px;
    color: #999;
}

.faq-type {
    background: #f0f0f0;
    padding: 4px 12px;
    border-radius: 4px;
    font-weight: 500;
}

.faq-date {
    font-style: italic;
}

/* 全部展开/收起按钮 */
.btn-toggle-all {
    background: #007bff;
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.btn-toggle-all:hover {
    background: #0056b3;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.btn-toggle-all:active {
    transform: translateY(0);
}

.btn-toggle-all i {
    font-size: 14px;
}

/* 过渡动画 */
.slide-fade-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

/* 响应式设计 */
@media (max-width: 767px) {
    .diet {
        font-size: 28px;
    }

    .card {
        padding: 20px;
    }

    .faq-title {
        font-size: 20px;
    }
    
    .toggle-icon {
        font-size: 18px;
    }

    .faq-content {
        font-size: 14px;
    }

    .faq-meta {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
}
</style>
